export default __webpack_public_path__ + "static/media/pictogramBeaconDigiWallet48.1907d5ca.svg";